// extracted by mini-css-extract-plugin
export default {"divPrincipal":"AssociadoForm_divPrincipal__DfClN","form":"AssociadoForm_form__uqnBp","label":"AssociadoForm_label__lKLz1"};